export const footerText = `Copyright Islamic Children Study Academy © ${new Date().getFullYear()}`;
